import { Link, NavLink, useNavigate } from 'react-router-dom';
import logo from './logo.png';

function Header({ user, logout, onlineUsers }) {
    const navigate = useNavigate();

    return (
        <header className="sticky top-0 z-50 w-full border-b border-white/10 shadow-lg bg-black/80 backdrop-blur-md py-4 font-josefin transition-all duration-300">
            <div className="max-w-7xl mx-auto px-4 flex flex-col sm:flex-row sm:items-center justify-between gap-4 sm:gap-0">
                <Link to="/" className="flex items-center gap-3 group">
                    <img src={logo} alt="VipEncuentros" className="h-12 w-auto transition-transform duration-300 group-hover:scale-105" />
                    <div>
                        <h1 className="text-2xl sm:text-3xl font-bold tracking-wide leading-tight text-white">
                            <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-400 via-yellow-200 to-yellow-500 drop-shadow-sm">Vip</span>Encuentros.com
                        </h1>
                        <p className="text-xs sm:text-sm text-white/50 font-light tracking-wider">
                            Sitio N°1 de servicios masculinos
                        </p>
                    </div>
                </Link>

                {/* Online Users Indicator */}
                <div className="relative flex items-center gap-2 bg-green-900/30 text-green-400 px-3 py-1.5 rounded-full text-xs font-bold border border-green-500/20 shadow-[0_0_10px_rgba(74,222,128,0.1)] animate-pulse">
                    <span className="pointer-events-none w-2 h-2 bg-green-500 rounded-full animate-ping absolute opacity-75"></span>
                    <span className="w-2 h-2 bg-green-500 rounded-full relative"></span>
                    {onlineUsers} personas buscando ahora
                </div>

                <nav className="hidden md:flex items-center gap-8 text-sm uppercase tracking-wider font-medium">
                    <NavLink to="/" className={({ isActive }) => isActive ? 'text-white border-b-2 border-yellow-500' : 'text-white/80 border-b-2 border-transparent'}>
                        Inicio
                    </NavLink>
                    {user && user.isAdmin && (
                        <NavLink to="/admin" className={({ isActive }) => isActive ? 'text-yellow-400 border-b-2 border-yellow-500' : 'text-yellow-500/80 border-b-2 border-transparent hover:text-yellow-400'}>
                            Admin Panel
                        </NavLink>
                    )}
                </nav>

                <div className="flex items-center gap-4 relative z-[60]">
                    {user ? (
                        <div className="flex items-center gap-4">
                            {user.isAdmin && (
                                <Link to="/admin" className="text-sm font-bold text-yellow-500 hover:text-yellow-400 font-josefin uppercase">
                                    ADMIN
                                </Link>
                            )}
                            <button onClick={logout} className="text-sm text-white/70 hover:text-white underline font-josefin">
                                SALIR
                            </button>
                        </div>
                    ) : (
                        <button
                            onClick={() => navigate('/login')}
                            className="inline-block text-sm font-bold text-yellow-400 hover:text-yellow-300 border border-yellow-500/50 px-4 py-2 rounded-full transition hover:bg-yellow-500/10 uppercase tracking-widest"
                            type="button"
                        >
                            Ingresar
                        </button>
                    )}
                    <Link
                        to="/publicar"
                        className="inline-block bg-gradient-to-r from-yellow-600 to-yellow-400 hover:from-yellow-500 hover:to-yellow-300 text-black font-bold px-6 py-2.5 rounded-full shadow-lg hover:shadow-yellow-500/20 transform hover:-translate-y-0.5 transition-all duration-300 text-sm tracking-wide uppercase"
                    >
                        Publicar
                    </Link>
                </div>
            </div>
        </header>
    );
}

export default Header;
